import React from 'react';
import {
  components as DefaultSelectComponents,
  ValueContainerProps,
} from 'react-select';
import { useTranslation } from 'react-i18next';
import styles from '../Select.module.scss';

export default function ChipMultiValueContainerForChipControl(
  props: ValueContainerProps,
): React.ReactElement {
  const { children, ...valueContainerProps } = props;
  const { isMulti, selectProps } = valueContainerProps;
  // @ts-ignore TODO: fix it (https://react-select.com/typescript#custom-select-props)
  const { chipControlProps } = selectProps;
  const { t } = useTranslation();

  if (isMulti && Array.isArray(children) && children.length) {
    const label = chipControlProps?.label ? (
      chipControlProps.label
    ) : (
      <>
        {/* {children[0]} */}
        {t('selected')}
        {!!children[0].length && ` (${children[0].length})`}
      </>
    );
    return (
      // @ts-ignore
      <DefaultSelectComponents.ValueContainer
        {...valueContainerProps}
        className={styles.valueContainer}
      >
        <span className={styles.multiValueWrapWithLabelOnly}>
          {label}
          <span
            style={{
              opacity: 0,
              width: 0,
              left: '-100px',
              position: 'relative',
            }}
          >
            {children[1]}
          </span>
        </span>
      </DefaultSelectComponents.ValueContainer>
    );
  }

  return (
    // @ts-ignore
    <DefaultSelectComponents.ValueContainer
      {...valueContainerProps}
      className={styles.valueContainer}
    >
      {children}
    </DefaultSelectComponents.ValueContainer>
  );
}
